export enum PictureUploadType {
  PROFILE = "Profile",
  COVER = "Cover",
}